import { AppState } from '../state/AppState';
import { DisplaySettings } from '../state/DisplaySettingsState';

export function selectDisplaySettings(state: AppState): DisplaySettings {
  return state.displaySettings;
}
